import { atom } from 'recoil';

export const OrderPayload = atom({
    key: 'ssoOkta-modify-OrderPayload',
    default: {
        applicationCI: null,
        applicationCIDetails: null,
        applicationOwner: null,
        applicationOwnerDetails: null,
        applicationName: null,
        appShortName: null,
        applicationUrl: null,
        loginUrl: [],
        logoutUrl: [],
        environment: null,
        envShortName: null,
        businessApplicationDetails: null,
        sector: null,
        member: null,
        memberDetails: null,
        requestType: null,
        audienceURI: null,
        isTouched: false,
        destinationUrl: null,
        recipientUrl: null,
        isLogoutUrlRequired: 'no',
        applicationLogoRequired: 'no',
        disclaimerAcknowledged: false,
        deletedFiles: [],
    },
});

export const orderId = atom({
    key: 'ssoOkta-modify-orderId',
    default: undefined,
});

export const isAppNameValid = atom({
    key: 'ssoOkta-modify-isAppNameValid',
    default: true,
});

export const isAppUrlValid = atom({
    key: 'ssoOkta-modify-isAppUrlValid',
    default: true,
});

export const isLoginUrlValid = atom({
    key: 'ssoOkta-modify-isLoginUrlValid',
    default: true,
});

export const isLogoutUrlValid = atom({
    key: 'ssoOkta-modify-isLogoutUrlValid',
    default: true,
});

export const ssoOktaDialogPopup = atom({
    key: 'ssoOkta-modify-ssoOktaDialogPopup',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 'ssoOkta-modify-isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'ssoOkta-modify-isAppShortNameExist',
    default: false,
});

export const toggleModels = atom({
    key: 'ssoOkta-modify-toggleModels',
    default: {
        isRoleOpen: false,
        isLoginModelOpen: false,
        isLogoutModelOpen: false,
    },
});

export const isAcsUrlValid = atom({
    key: 'ssoOkta-modify-isAcsUrlValid',
    default: true,
});

export const isAudienceURIValid = atom({
    key: 'ssoOkta-modify-isAudienceURIValid',
    default: true,
});

export const uploadedFilesState = atom({
    key: 'ssoOkta-modify-uploadedFilesState',
    default: [],
});

export const isDataClassificationValid = atom({
    key: 'ssoOkta-modify-isDataClassificationValid',
    default: true,
});

export const isApplicationClientNameValid = atom({
    key: 'ssoOkta-modify-isApplicationClientNameValid',
    default: true,
});
